<!--
 * @Author: your name
 * @Date: 2020-11-20 17:58:25
 * @LastEditTime: 2021-04-20 17:31:51
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \xingmahui_front\src\views\archives\babyArchives.vue
-->
<template>
  <div class="baby-archives">
    <go-back @goBack="goBack" />
    <div class="back" @click.stop="goBack">
      <img src="@/assets/images/Profile/profile/back.png" alt="" />
    </div>
    <div class="baby_container">
      <div class="baby_card">
        <div class="baby_tab">
          <div class="baby_image">
            <div
              v-for="(item, index) in babyInfo"
              :key="index"
              @click="swichBabyChange(index)"
              :class="[changeBabyTab == index ? 'baby_tab_active' : '',item.pic !== '' ?item.sex =='M'?'baby_tab_man':'baby_tab_woman' :'']"
              :style="{backgroundImage: 'url(' + (item.pic?item.pic:item.sex=='M'?manHead:item.sex == 'O'||item.sex == ''? unknownsHead:womanHead) + ')',backgroundSize:'100% auto',backgroundRepeat: 'no-repeat',backgroundPosition:'center', borderRadius: '50%'}"
              alt=""
            />
          </div>
        </div>
        <div class="baby_name" v-if="babyInfo != null">
          <p>{{ (babyInfo[changeBabyTab].nick && babyInfo[changeBabyTab].nick!='')? babyInfo[changeBabyTab].nick:'鹤小宝' }}</p>
          <div>
            <img :src="babyInfo[changeBabyTab].sex == 'M' ?sexMan:babyInfo[changeBabyTab].sex == 'O'||babyInfo[changeBabyTab].sex == '' ?sexUnknowns:sexWoman" alt="" />
            <p v-if="babyDays != null">
              {{ changeBabyTab ? babyDays.secondtime : babyDays.firsttime }}
            </p>
          </div>
        </div>
      </div>
      <!-- <div class="baby_card" v-if="babyChange">
        <mySwiper
          :slidesNum="slidesNum"
          :spaceBetweenNum="15"
          :loop="false"
          :swipeid="'archives_card_swiper'"
          :transitionEndFn="transitionEndFn"
          @pageChange="pageChange"
          v-if="babyInfo"
        > -->
      <!-- <baby-card
            :babyInfo="item"
            :babyDays="babyDays"
            v-for="(item, index) in babyInfo"
            :key="index"
          ></baby-card> -->
      <!-- </mySwiper>
      </div> -->

      <div class="archives">
        <!-- 测量结果 -->
        <div class="measuring_result public_style" v-if="growthSituation">
          <p class="fixed_day">*测量于{{toDay(growthSituation.recordDate)}}</p>
          <ul>
            <li>
              <p>{{threeW.height}}</p>
              <p>身高</p>
            </li>
            <li>
              <p>{{threeW.weight}}</p>
              <p>体重</p>
            </li>
            <li>
              <p>{{threeW.head?threeW.head:bmi}}</p>
              <p>{{threeW.head?"头围":"BMI"}}</p>
            </li>
          </ul>
        </div>
        <div class="baby_change public_style" v-if="babyChange">
          <div class="title">
            <div class="icon"></div>
            <span>当前变化</span>
            <img @click="onClickBabyChange" src="@/assets/images/Profile/profile/jump_more.png" alt="">
          </div>
          <p class="baby_content" @click="onClickBabyChange">
            {{ babyChange }}
          </p>
        </div>

        <growthSituation
          :growthSituation="growthSituation"
          :showRecordsBaby="timeOut"
          :showHeadState="curHeadState"
          :num="num"
          v-if="babyChange"
          @getThree="getThree"
        ></growthSituation>

        <div class="file_summary public_style">
          <div class="title">
            <div class="icon"></div>
            <span>档案小结</span>
          </div>
          <p class="file_content" v-if="fileSummary">
            {{ fileSummary }}
          </p>
          <div class="no_file" v-else>
            <div>
              <img
                src="@/assets/images/Profile/profile/no_baby_record.png"
                alt=""
              />
              <p>暂时还没有宝宝档案～</p>
            </div>
          </div>
        </div>
        <!-- 其他工具 -->
        <div class="file_summary public_style other_tools">
          <div class="title">
            <div class="icon"></div>
            <span>其他工具</span>
          </div>
          <ul>
            <li @click="toTool(0)">
              <img
                src="@/assets/images/Profile/profile/eat_records.png"
                alt=""
              />
              <img class="new-hot" src="../../../assets/images/Profile/profile/new.png" alt="">
              <p>喂养记录</p>
            </li>
            <li @click="toTool(1)">
              <img
                src="@/assets/images/Profile/profile/baby_is_eat.png"
                alt=""
              />
              <img class="new-hot" src="../../../assets/images/Profile/profile/new.png" alt="">
              <p>能不能吃</p>
            </li>
            <li @click="toTool(2)">
              <img src="@/assets/images/Profile/profile/baby_barn.png" alt="" />
              <p>宝宝粮仓</p>
            </li>
            <li @click="toTool(3)">
              <img src="@/assets/images/Profile/profile/baby_tips.png" alt="" />
              <p>育儿贴士</p>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import goBack from "@/components/common/goBack"; //返回组件
import API from "@/utils/axiosApi/contentToolsApi.js";
import { getCookie, is_weixin } from "@/assets/js/common.js";
import mySwiper from "@/components/common/mySwiper/mySwiper.vue";
import babyCard from "@/components/contents/archives/babyCard.vue";
import mobiledetect from "@/assets/js/mobile-detect.js";
import growthSituation from "@/components/contents/archives/growthSituation.vue";
import { refPowder } from '@/utils/mockData/referMilkData'
export default {
  name: "archives",
  data() {
    return {
      UserInfo: null, // localStorage中获取用户信息
      babyInfo: null, //swiper需要的宝宝信息
      babyChange: null, //宝宝变化数据(s)
      growthSituation: null, //生长情况数据
      babyChangeSwitch: [], //宝宝变化缓存数据(s)
      babyCardIndex: 0, // 宝宝卡片的索引
      fileSummary: null, //档案小结
      timeOut: "", // 超时文字展示
      curHeadState: false, // 宝宝超三岁头围状态
      // backImg: require('./../../../assets/images/icon/goback.png'),
      // backImg2: require('./../../../assets/images/icon/back2.png'),
      slidesNum: 0, // 宝宝卡片宽度展示
      num: 1, // 宝宝胎次
      babyDays: null, // 宝宝月龄,
      changeBabyTab: 0, //宝宝tab切换
      manHead: require("../../../assets/images/Profile/profile/baby_man.png"), // 男宝默认头像
      womanHead: require("../../../assets/images/Profile/profile/baby_woman.png"), // 女宝默认头像
      unknownsHead: require("../../../assets/images/Profile/profile/baby_unknowns.png"), // 女宝默认头像
      sexMan: require("../../../assets/images/Profile/profile/sex_man.png"), // 男
      sexWoman: require("../../../assets/images/Profile/profile/sex_woman.png"), // 女
      sexUnknowns: require("../../../assets/images/Profile/profile/sex_unknowns.png"), // 未知
      threeW:{},//宝宝身高体重头围
      bmi:null //三岁以上无头围显示
    };
  },
  computed: {
    // 当改变了宝宝卡片的索引时,传入索引,用来当做拿数据时所用的变量
    // formateGrowthSituation() {
    // }
    // formatHeight () {
    //   return (this.growthSituation.height / 10).toFixed(1)
    // },
    // formatWeight () {
    //   return (this.growthSituation.weight / 1000).toFixed(1)
    // },
    // formatHead () {
    //   return (this.growthSituation.head + 0).toFixed(1)
    // },
  },
  components: { mySwiper, babyCard, growthSituation ,goBack},
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (vm.is_weixin()) {
        //微信中
        if (
          vm.getCookie("xmh_openid") == null ||
          vm.getCookie("xmh_openid") == ""
        ) {
          //判断有没有openId
          location.href =
            "/xmh/v2/wechat/oauth2/authorize?url=" +
            encodeURIComponent(window.location.href);
        } else {
          vm.userOpenid = vm.getCookie("xmh_openid");
          vm.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
          vm.wxJsSet.getUserInfoBywx(
            vm,
            function() {
              vm.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
              gio("setUserId", vm.UserInfo.crm_id);
              if (
                vm.UserInfo.mobile == null ||
                vm.UserInfo.mobile == "" ||
                vm.UserInfo.mobile == "null"
              ) {
                //没有手机号未注册
                sensors.login(vm.getCookie("xmh_unionid"));
                vm.profileShow = false;
                vm.loginShow = true;
                // vm.getUserLog()
              } else {
                vm.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
                sensors.login(vm.UserInfo.crm_id);
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                  if (vm.getCookie("xmh_nickname") == "") {
                    vm.userName = vm.UserInfo.full_name;
                  } else {
                    vm.userName = vm.getCookie("xmh_nickname");
                  }
                } else {
                  vm.userName = vm.UserInfo.full_name;
                }
                vm.profileShow = true;
                vm.loginShow = true;
                vm.initPage();
              }
            },
            function() {
              if (
                vm.UserInfo == null ||
                vm.UserInfo == "" ||
                vm.UserInfo.mobile == null ||
                vm.UserInfo.mobile == "" ||
                vm.UserInfo.mobile == "null"
              ) {
                //没有手机号未注册
                sensors.login(vm.getCookie("xmh_unionid"));
                vm.profileShow = false;
                vm.loginShow = true;
                // vm.getUserLog()
              } else {
                vm.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
                sensors.login(vm.UserInfo.crm_id);
                if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
                  if (vm.getCookie("xmh_nickname") == "") {
                    vm.userName = vm.UserInfo.full_name;
                  } else {
                    vm.userName = vm.getCookie("xmh_nickname");
                  }
                } else {
                  vm.userName = vm.UserInfo.full_name;
                }
                vm.profileShow = true;
                vm.loginShow = true;
                vm.initPage();
              }
            }
          );
        }
      } else {
        vm.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
        if (
          vm.getCookie("xmh_phone") == null ||
          vm.getCookie("xmh_phone") == "" ||
          vm.UserInfo == null ||
          vm.UserInfo == ""
        ) {
          //未登录
          sensors.login(vm.getCookie("xmh_unionid"));
          vm.profileShow = false;
          vm.loginShow = true;
          // vm.getUserLog()
        } else {
          sensors.login(vm.UserInfo.crm_id);
          if (vm.UserInfo.mobile == vm.UserInfo.full_name) {
            if (vm.getCookie("xmh_nickname") == "") {
              vm.userName = vm.UserInfo.full_name;
            } else {
              vm.userName = vm.getCookie("xmh_nickname");
            }
          } else {
            vm.userName = vm.UserInfo.full_name;
          }
          vm.profileShow = true;
          vm.loginShow = true;
          vm.initPage();
        }
      }
      vm.UserInfo = JSON.parse(localStorage.getItem("userInfo"));
    });
  },
  created() {},
  beforeDestroy() {},
  mounted() {
    let shareURL = location.origin + "/home"
    var shareDataParams = {
      shareLink: shareURL,
      shareDesc: "超1000万中国家庭都在看，快乐育儿，全程陪伴，源于母爱。",
      shareTitle: "星妈会",
      imgUrl: "https://image-mom.feihe.com/wxshare/home.png", //必须是绝对路径
    };
    this.wxJsSet.wxShare("fx", shareDataParams, this);
  },
  methods: {
    // 初始化显示页面
    initPage: function() {
      this.getBabyInfos();
    },
    is_weixin,
    getCookie,
    mobiledetect,
    // 跳转工具页面
    toTool(index){
      
      let EndTime  = new Date(this.babyInfo[this.babyCardIndex].birth)
      let NowTime  = new Date()
      let t = NowTime.getTime() - EndTime.getTime();
      var monthAge = Math.floor(t / 1000 / 60 / 60 / 24 / 30);
      let maxNum
      if(monthAge > 36){
        monthAge = 40
        maxNum = 0
      }else{
        maxNum = refPowder[monthAge].maximum
      }
      var toToolPath = ["/feedRecord","/canEatList","/newBabyBarn","/parentingTips"]
      
      if(index === 0){
        this.$router.push({path:toToolPath[index],query:{monthAge,month:this.babyCardIndex === 0?this.babyDays.firsttime:this.babyDays.secondtime,num:this.babyCardIndex+1}})
        return false
      }
      if(index ===2){
        this.$router.push({path:toToolPath[index],query:{monthAge,maxNum}})
        return false
      }
      if(index === 3){
        location.href = `/parentingTips?sourceFrom=babyArchives&num=${this.num}&bir=${this.babyInfo[this.babyCardIndex].birth}`;
        return false
      }
      this.$router.push({path:toToolPath[index]})
    },
    // 宝宝身高转化接收
    getThree(res){
      if(res.head){
        this.threeW.head = res.head + "cm"
      }else{
        if(this.babyChangeSwitch[this.changeBabyTab] && this.babyChangeSwitch[this.changeBabyTab].newRecord[0]){
          console.log(this.babyChangeSwitch[this.changeBabyTab])
          this.threeW.head = null
          this.bmi = this.babyChangeSwitch[this.changeBabyTab].newRecord[0].bmi
        }
      }
      if(res.weight){
        this.threeW.weight = res.weight + "kg"
      }
      if(res.height){
        this.threeW.height = res.height + "cm"
        
      }
      this.$forceUpdate()
    },
    // 计算几天前评论
    toDay(day){
      let EndTime  = new Date(day)
      let NowTime  = new Date()
      let t = NowTime.getTime() - EndTime.getTime();
      var d = Math.floor(t / 1000 / 60 / 60 / 24);
      if(d > 999){
        d = 999
      }
      if(d === 0){
        return "今天"
      }else{
        return d + "天前"
      }
    },
    // 获取宝宝信息
    getBabyInfos() {
      API.getBabyInfo({ crmId: this.UserInfo.crm_id }, (res) => {
        if (res.code == "200") {
          // console.log(res);
          if (res.data && res.data.length) {
            localStorage.setItem("babyNum", res.data.length);
            var babyFilter = [];
            // 只要有宝宝时,当孕育转出生时设置默认性别
            res.data.forEach((element) => {
              if (element.tag_id > 2) {
                if (element.sex != "M" && element.sex != "F") {
                  element.sex = "M";
                }
                babyFilter.push(element);
              }
            });

            // 设置宝宝卡片的宽度
            if (babyFilter.length == 1) {
              this.slidesNum = 0;
            } else {
              this.slidesNum = 1.148;
            }

            // 调用宝宝成长记录接口设置默认值
            this.gettingBabyInfo(this.UserInfo, babyFilter[0]).then(res=>{
              return new Promise((resolve,reject)=>{
                resolve(res)
              })
            }).then(data=>{
              // 进入离开页面如果是二胎则自动切换二胎
              if(getCookie("babyNum") == 2){
                this.swichBabyChange(1)
              }
            })

            this.num = babyFilter[0].num;

            // 渲染swiper时需要的数据
            this.babyInfo = babyFilter;
            console.log(this.babyInfo)
            if(res.data.length > 1){
              this.getBabyDay(res.data[0].birth, res.data[1].birth);
            }else{
              this.getBabyDay(res.data[0].birth);
            }

            
          } else {
            localStorage.setItem("babyNum", 0);
          }
        }
      });
    },
    onClickLeft() {
      this.$toast({
        message: "返回到上一页",
        forbidClick: true,
        duration: 2000,
        context: this,
      });
    },
    // 监听轮播图事件
    // transitionEndFn() {
    //   this.$emit("pageChange", this.dom.activeIndex);
    // },
    // pageChange(index) {
    //   if (this.babyInfo.length > 1) {
    //     // 回传索引与当前索引不同
    //     if (this.babyCardIndex !== index) {
    //       this.babyCardIndex = index;
    //       this.swichBabyChange(index);
    //     }
    //   }
    // },
    // 滑动轮播图时,页面填入不同数据,把babychangeman与woman赋值给babyChange
    async swichBabyChange(index) {
      this.changeBabyTab = index; //宝宝胎次选择
      this.babyCardIndex = index; //跳转对应的宝宝胎次
      document.cookie=`babyNum=${this.babyCardIndex+1}`
      // 接口懒加载
      if (this.babyInfo.length != this.babyChangeSwitch.length) {
        var otherBabyInfo = this.babyInfo.filter(
          (el) => el.num != this.babyInfo[0].num
        );
        console.log(otherBabyInfo)
        for (let i = 0; i < otherBabyInfo.length; i++) {
          await this.gettingBabyInfo(this.UserInfo, otherBabyInfo[i]);
        }
      }
      console.log(this.babyChangeSwitch)
      this.babyChange = this.babyChangeSwitch[index].babyChange; //0
      if (this.babyChangeSwitch[index]) {
        this.growthSituation =
          this.babyChangeSwitch[index].newRecord.length == 0
            ? null
            : this.babyChangeSwitch[index].newRecord[0]; // 0
        this.fileSummary =
          this.babyChangeSwitch[index].newRecord.length == 0
            ? null
            : this.babyChangeSwitch[index].newRecord[0].summary;
        this.timeOutFn(
          this.babyInfo[index],
          this.babyChangeSwitch[index].newRecord
        );
      }
      // 为空展示
      // if(this.changeBabyTab === 1){
      //   this.growthSituation = null
      //   this.fileSummary = null
      // }
      this.showHeadState(this.babyInfo[index]);
      this.num = this.babyInfo[index].num;
    },
    // 获取当前宝宝的信息(baby都是育儿状态的宝宝且胎次可能不是一)
    gettingBabyInfo(user, baby) {
      return new Promise((reslove) => {
        API.getBabyArchive(
          {
            crmId: user.crm_id,
            childNumber: baby.num,
            birthday: baby.birth,
            sex: baby.sex !== "" && baby.sex !== "O"?baby.sex:"M",
          },
          (res) => {
            this.babyChangeSwitch.push(res.data);
            // 设置默认值
            if (this.babyInfo[0].num == baby.num) {
              this.showHeadState(this.babyInfo[0]);
              this.timeOutFn(baby, res.data.newRecord);
              this.babyChange = this.babyChangeSwitch[0].babyChange;
              this.growthSituation =
                this.babyChangeSwitch[0].newRecord.length == 0
                  ? null
                  : this.babyChangeSwitch[0].newRecord[0]; // 0
              this.fileSummary =
                this.babyChangeSwitch[0].newRecord.length == 0
                  ? null
                  : this.babyChangeSwitch[0].newRecord[0].summary;
            }
            console.log(res)
            reslove(res.data);
          }
        );
      });
    },
    // 超时数据处理
    timeOutFn(baby, growthSituation) {
      var birDiff = new Date() - new Date(baby.birth);
      var dateDiff = new Date() - new Date(growthSituation.createTime);
      var bir = Math.floor(birDiff / (30 * 24 * 3600 * 1000));
      var day = Math.floor(dateDiff / (24 * 3600 * 1000)); // 这是上传创建到现在的天数
      if (0 <= bir && bir < 24 && day >= 15) {
        return "半";
      } else if (24 <= bir && bir <= 35 && day >= 30) {
        return "1";
      } else if (35 < bir && day >= 60) {
        return "2";
      }
    },
    // 宝宝超过三岁无头围情况
    showHeadState(curbaby) {
      if (curbaby) {
        curbaby.tag_id == "6"
          ? (this.curHeadState = false)
          : (this.curHeadState = true);
        // if (curbaby.tag_id == '6') {
        //     this.curHeadState = false
        // } else {
        //     this.curHeadState = true
        // }
      }
    },
    onClickBabyChange() {
      location.href = `/parentingTips?sourceFrom=babyArchives&num=${
        this.num
      }&bir=${this.babyInfo[this.babyCardIndex].birth}`;
      // this.$router.push(`/parentingTips?sourceFrom=babyArchives&num=${this.num}&bir=${this.babyInfo[this.babyCardIndex].birth}`)
    },
    // 返回上一页
    goBack: function() {
      this.$router.push({ path: "/home" });
    },
    // 获取宝宝日期
    getBabyDay(birth1, birth2) {
      if (!this.babyDays) {
        API.getBabyDays({}, { first: birth1, second: birth2 }, (res) => {
          if (res.code == "200") {
            this.babyDays = res.data;
          }
        });
      }
    },
  },
  filters: {
    colorFormat (stateNum) {
      return growState && growState.colorState[stateNum - 1]
    },
    dataFormat (stateNum) {
      return growState && growState.dataState[stateNum - 1]
    },
    headFormat (stateNum) {
      return growState && growState.headState[stateNum - 1]
    }
  },
};
</script>

<style scoped lang="less">
.baby-archives {
  overflow-x: hidden;
}
.back {
  width: 10px;
  position: absolute;
  top: 7px;
  left: 12px;
  z-index: 2;
  img {
    width: 10px;
    height: 16px;
    // position: fixed;
  }
}
.baby_container {
  padding-bottom: 22px;
  .baby_card {
    box-sizing: border-box;
    padding: 11px 21px 0px 30px;
    width: 100%;
    height: 157px;
    background: url(../../../assets/images/Profile/profile/barn_bgImg.png)
      no-repeat;
    background-size: 100% 100%;
    .baby_tab {
      .baby_image {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        div {
          width: 42px;
          height: 42px;
        }
        div:nth-of-type(1) {
          z-index: 1;
        }
        div:nth-of-type(2) {
          margin-left: -8px;
        }
        .baby_tab_active {
          border-radius: 50%;
          width: 58px;
          height: 58px;
          z-index: 2;
        }
        .baby_tab_man{
          box-sizing: border-box;
          border-radius: 50%;
          border: 1px solid #A2C7FF;
        }
        .baby_tab_woman{
          box-sizing: border-box;
          border-radius: 50%;
          border: 1px solid #FFA6CE;
        }
      }
    }
    .baby_name {
      display: flex;
      p {
        margin-right: 12px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #333333;
        font-size: 14px;
      }
      div {
        display: flex;
        align-items: center;
        img {
          width: 12px;
          height: 12px;
          margin-right: 2px;
        }
        p {
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #333333;
        }
      }
    }
  }
  .archives {
    // border: 1px solid #cfcfcf;
    margin: -61px 12px 0px 12px;
    // 测量结果
    .measuring_result {
      position: relative;
      box-sizing: border-box;
      padding: 0;
      height: 89px;
      background-image: url(../../../assets/images/Profile/profile/three_bgImg.png);
      background-size: 100% 100%;
      ul {
        height: 100%;
        display: flex;
        justify-content: space-around;
        align-items: center;
        padding-top: 10px;
        li {
          text-align: center;
          p:nth-of-type(1) {
            font-size: 20px;
            font-family: DINAlternate-Bold, DINAlternate;
            font-weight: bold;
            color: #333333;
          }
          p:nth-of-type(2) {
            margin-top: 4px;
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #666666;
          }
        }
      }
      .fixed_day {
        position: absolute;
        font-size: 12px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #999999;
        top: 4px;
        left: 4px;
      }
    }

    // 宝宝变化
    .baby_change {
      padding-bottom: 10px;
      .title {
        height: 18px;
        line-height: 18px;
        color: #333;
        padding: 14px 0;
        font-size: @indexFontSize18;
        font-weight: 600;
        img{
          width: 12px;
          height: 10px;
          float: right;
        }
        .icon {
          position: relative;
          top: 3px;
          display: inline-block;
          width: 6px;
          height: 18px;
          border-radius: 3px;
          margin-right: 4px;
          background-color: #ffa5a5;
        }
        span {
          display: inline-block;
        }
      }
      .baby_content {
        font-size: @indexFontSize14;
        line-height: 22px;
        color: #333;
      }
    }

    //档案小结
    .file_summary {
      margin: 0;
      padding-bottom: 6px;
      .title {
        height: 18px;
        line-height: 18px;
        color: #333;
        padding: 14px 0;
        font-size: @indexFontSize18;
        font-weight: 600;
        .icon {
          position: relative;
          top: 3px;
          display: inline-block;
          width: 6px;
          height: 18px;
          border-radius: 3px;
          margin-right: 4px;
          background-color: #ffa5a5;
        }
        span {
          display: inline-block;
        }
      }
      .file_content {
        font-size: @indexFontSize14;
        line-height: 22px;
        color: #333;
      }
      ul {
        margin-top: 4px;
        display: flex;
        justify-content: space-around;
        padding-bottom: 10px;
        li {
          width: 50px;
          text-align: center;
          position: relative;
          img {
            width: 26px;
            height: 26px;
          }
          p {
            margin-top: 5px;
            font-size: 12px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: #333333;
          }
          .new-hot{
            position: absolute;
            width: 17px;
            height: 12px;
            right:6px;
            top: -6px;
          }
        }
      }
    }
    // 其他工具
    .other_tools {
      height: 106px;
      margin-top: 10px;
    }
    // 档案无数据
    .no_file {
      padding: 20px 0px 18px 0px;
      div {
        text-align: center;
        img {
          width: 184px;
          height: 131px;
        }
        p {
          margin-top: 6px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: #666666;
        }
      }
    }
    /deep/ .van-divider--hairline {
      margin: 8px 0;
    }
  }
}

// 显示三行溢出隐藏
.text_limit {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box; //作为弹性伸缩盒子模型显示。
  -webkit-box-orient: vertical; //设置伸缩盒子的子元素排列方式--从上到下垂直排列
  -webkit-line-clamp: 3; //显示的行
}

.growth_section_first {
  background-color: #555555;
  border-radius: 5px 0 0 5px;
}
.growth_section_second {
  background-color: #666;
}
.growth_section_third {
  background-color: #909090;
}
.growth_section_fourth {
  background-color: #b9b9b9;
}
.growth_section_fifth {
  background-color: #e8e8e8;
  border-radius: 0 5px 5px 0;
}

.public_style {
  background-color: #fff;
  margin-bottom: 10px;
  border-radius: 8px;
  padding: 0 14px;
  padding-bottom: 14px;
}
</style>
